import {Component, Input, OnInit} from '@angular/core';

import {NbMenuService, NbSearchService, NbSidebarService} from '@nebular/theme';

import {AnalyticsService} from '../../../@core/utils/analytics.service';
import {UserService} from '../../../services/user/user.service';
import {ShardHandlerService} from '../../../services/sharding/shard-handler.service';
import {User} from '../../../models/user';
import {filter, map} from 'rxjs/operators';
import {AuthenticationService} from '../../../services/authentication/authentication.service';
import {BrandingService} from '../../../services/branding/branding.service';
import {NewMessageObserverService} from '../../../services/new-message-observer/new-message-observer.service';
import {Router} from '@angular/router';
import {ApiService} from '../../../services/api/api.service';
import {ConfigService} from '../../../services/config/config.service';
import {buildVersionedTitle} from '../../../helpers/app-title/app-title';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  @Input() position = 'normal';

  user: User;
  companyName: string = '';

  userMenu = [{title: 'Profile', link: '/admin/account'}, {title: 'Log out', target: 'logout'}];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private userService: UserService,
              private analyticsService: AnalyticsService,
              private authService: AuthenticationService,
              public brandingService: BrandingService,
              public newMessageObserverService: NewMessageObserverService,
              private router: Router,
              private searchService: NbSearchService,
              private api: ApiService,
              private shardHandler: ShardHandlerService,
              private config: ConfigService) {
    this.searchService.onSearchSubmit()
      .subscribe((data: any) => {
        this.router.navigateByUrl('/admin/search?q=' + data.term);
      });
  }

  ngOnInit() {
    const vm = this;

    this.shardHandler.get().then(data => {
      vm.companyName = buildVersionedTitle(data['data']['name'], this.config.get('appVersion') as string);
    })

    this.userService.self().then((user) => {
      vm.user = user;
      vm.userService.currentUser = user;

      this.menuService.onItemClick()
        .pipe(
          filter(({tag}) => tag === 'header-profile-menu'),
          map(({item: {target}}) => target),
        )
        .subscribe(tag => {
          if (tag === 'logout') {
            vm.authService.logout();
          }
        });
    });
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }

  pad(n, width = 2, z = '0') {
    n = n ? n : 0;
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  goToMessages() {
    this.router.navigate(['/admin/messages']);
  }
}
